var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'display': _vm.active.visible? 'block' : 'none'}),attrs:{"id":"progressLayer"}},[_c('div',{staticClass:"wrap_layer"},[_vm._v("in progress")])])}
var staticRenderFns = []

export { render, staticRenderFns }